import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi';
import { z } from 'zod';

extendZodWithOpenApi(z);

export * from './common/constants';
export * from './common/electrodb';
export * from './common/enums';
export * from './common/schemas';
export * from './common/sql';
export * from './common/types';
export * from './common/utils';

export * from './assets/codecs';
export * from './assets/constants';
export * from './assets/enums';
export * from './assets/schemas';

export * from './appUsers/codecs';
export * from './appUsers/enums';
export * from './appUsers/schemas';

export * from './attempts/codecs';
export * from './attempts/enums';
export * from './attempts/schemas';

export * from './attemptScans/codecs';
export * from './attemptScans/constants';
export * from './attemptScans/enums';
export * from './attemptScans/schemas';

export * from './attemptSubmissions/codecs';
export * from './attemptSubmissions/constants';
export * from './attemptSubmissions/enums';
export * from './attemptSubmissions/schemas';

export * from './auditEvents/codecs';
export * from './auditEvents/enums';
export * from './auditEvents/schemas';

export * from './enrichmentRuns/codecs';
export * from './enrichmentRuns/enums';
export * from './enrichmentRuns/schemas';

export * from './classes/codecs';
export * from './classes/constants';
export * from './classes/enums';
export * from './classes/schemas';

export * from './courses/codecs';
export * from './courses/constants';
export * from './courses/enums';
export * from './courses/schemas';

export * from './documentQuestions/codecs';
export * from './documentQuestions/enums';
export * from './documentQuestions/schemas';

export * from './institutions/codecs';
export * from './institutions/enums';
export * from './institutions/schemas';

export * from './legacyExamAttempts/codecs';
export * from './legacyExamAttempts/constants';
export * from './legacyExamAttempts/enums';
export * from './legacyExamAttempts/schemas';

export * from './legacyExamMarkingRequests/codecs';
export * from './legacyExamMarkingRequests/constants';
export * from './legacyExamMarkingRequests/enums';
export * from './legacyExamMarkingRequests/schemas';

export * from './legacyExamQuestionAttempts/codecs';
export * from './legacyExamQuestionAttempts/constants';
export * from './legacyExamQuestionAttempts/enums';
export * from './legacyExamQuestionAttempts/schemas';

export * from './legacyExamQuestions/codecs';
export * from './legacyExamQuestions/constants';
export * from './legacyExamQuestions/enums';
export * from './legacyExamQuestions/schemas';

export * from './legacyExams/codecs';
export * from './legacyExams/constants';
export * from './legacyExams/enums';
export * from './legacyExams/schemas';

export * from './legacyExamTypes/codecs';
export * from './legacyExamTypes/constants';
export * from './legacyExamTypes/enums';
export * from './legacyExamTypes/schemas';

export * from './leads/codecs';
export * from './leads/constants';
export * from './leads/enums';
export * from './leads/schemas';

export * from './lessons/codecs';
export * from './lessons/constants';
export * from './lessons/enums';
export * from './lessons/schemas';

export * from './lessonEnrolments/codecs';
export * from './lessonEnrolments/constants';
export * from './lessonEnrolments/enums';
export * from './lessonEnrolments/schemas';

export * from './lessonTemplates/codecs';
export * from './lessonTemplates/constants';
export * from './lessonTemplates/enums';
export * from './lessonTemplates/schemas';

export * from './notesCategories/codecs';
export * from './notesCategories/constants';
export * from './notesCategories/enums';
export * from './notesCategories/schemas';

export * from './notes/codecs';
export * from './notes/constants';
export * from './notes/enums';
export * from './notes/schemas';

export * from './permissionGroups/codecs';
export * from './permissionGroups/constants';
export * from './permissionGroups/enums';
export * from './permissionGroups/schemas';

export * from './permissions/codecs';
export * from './permissions/constants';
export * from './permissions/enums';
export * from './permissions/schemas';

export * from './prices/codecs';
export * from './prices/constants';
export * from './prices/enums';
export * from './prices/schemas';

export * from './questionDigitisationRuns/codecs';
export * from './questionDigitisationRuns/constants';
export * from './questionDigitisationRuns/enums';
export * from './questionDigitisationRuns/schemas';

export * from './questionEnrichments/codecs';
export * from './questionEnrichments/enums';
export * from './questionEnrichments/schemas';

export * from './questionFaults/codecs';
export * from './questionFaults/enums';
export * from './questionFaults/schemas';
export * from './questionFaults/types';

export * from './questionOccurrences/codecs';
export * from './questionOccurrences/constants';
export * from './questionOccurrences/schemas';

export * from './questions/codecs';
export * from './questions/constants';
export * from './questions/enums';
export * from './questions/schemas';

export * from './questionSets/codecs';
export * from './questionSets/constants';
export * from './questionSets/enums';
export * from './questionSets/schemas';

export * from './rooms/codecs';
export * from './rooms/constants';
export * from './rooms/enums';
export * from './rooms/schemas';

export * from './schools/codecs';
export * from './schools/constants';
export * from './schools/enums';
export * from './schools/schemas';

export * from './sourceDocuments/codecs';
export * from './sourceDocuments/constants';
export * from './sourceDocuments/enums';
export * from './sourceDocuments/schemas';

export * from './staff/codecs';
export * from './staff/constants';
export * from './staff/enums';
export * from './staff/schemas';

export * from './studentActivityLog/codecs';
export * from './studentActivityLog/constants';
export * from './studentActivityLog/enums';
export * from './studentActivityLog/schemas';

export * from './studentSubjectAnalytics/codecs';
export * from './studentSubjectAnalytics/constants';
export * from './studentSubjectAnalytics/enums';
export * from './studentSubjectAnalytics/schemas';

export * from './legacyStudentTopicAnalytics/codecs';
export * from './legacyStudentTopicAnalytics/constants';
export * from './legacyStudentTopicAnalytics/enums';
export * from './legacyStudentTopicAnalytics/schemas';

export * from './streams/codecs';
export * from './streams/constants';
export * from './streams/enums';
export * from './streams/formatters';
export * from './streams/schemas';

export * from './students/codecs';
export * from './students/constants';
export * from './students/enums';
export * from './students/schemas';

export * from './legacyTopicGroups/codecs';
export * from './legacyTopicGroups/constants';
export * from './legacyTopicGroups/enums';
export * from './legacyTopicGroups/schemas';

export * from './legacyTopics/codecs';
export * from './legacyTopics/constants';
export * from './legacyTopics/enums';
export * from './legacyTopics/schemas';

export * from './topicGroups/codecs';
export * from './topicGroups/enums';
export * from './topicGroups/schemas';

export * from './topics/codecs';
export * from './topics/enums';
export * from './topics/schemas';

export * from './tutorials/codecs';
export * from './tutorials/constants';
export * from './tutorials/enums';
export * from './tutorials/schemas';

export * from './uploads/codecs';
export * from './uploads/constants';
export * from './uploads/enums';
export * from './uploads/schemas';

export * from './userNotes/codecs';
export * from './userNotes/constants';
export * from './userNotes/enums';
export * from './userNotes/schemas';

export * from './userPermissions/codecs';
export * from './userPermissions/constants';
export * from './userPermissions/enums';
export * from './userPermissions/schemas';

export * from './users/constants';
export * from './users/enums';
export * from './users/schemas';

export * from './videoCategories/codecs';
export * from './videoCategories/constants';
export * from './videoCategories/enums';
export * from './videoCategories/schemas';

export * from './videos/codecs';
export * from './videos/constants';
export * from './videos/enums';
export * from './videos/schemas';
export * from './videos/source';

export * from './vocabularies/codecs';
export * from './vocabularies/enums';
export * from './vocabularies/schemas';

/**
 * Mapping from plural folder names to singular entity names for schema matching
 * This handles cases where the folder is plural but schemas use singular names
 */
export const ValidationRegister: Record<string, string> = {
  appUsers: 'AppUser',
  attempts: 'Attempt',
  attemptScans: 'AttemptScan',
  attemptSubmissions: 'AttemptSubmission',
  auditEvents: 'AuditEvent',
  assets: 'Asset',
  enrichmentRuns: 'EnrichmentRun',
  classes: 'Class',
  courses: 'Course',
  documentQuestions: 'DocumentQuestion',
  institutions: 'Institution',
  leads: 'Lead',
  legacyExamAttempts: 'LegacyExamAttempt',
  legacyExamMarkingRequests: 'LegacyExamMarkingRequest',
  legacyExamQuestionAttempts: 'LegacyExamQuestionAttempt',
  legacyExamQuestions: 'LegacyExamQuestion',
  legacyExams: 'LegacyExam',
  legacyExamTypes: 'LegacyExamType',
  legacyStudentTopicAnalytics: 'LegacyStudentTopicAnalytics',
  legacyTopicGroups: 'LegacyTopicGroup',
  legacyTopics: 'LegacyTopic',
  lessonEnrolments: 'LessonEnrolment',
  lessons: 'Lesson',
  lessonTemplates: 'LessonTemplate',
  notes: 'Note',
  notesCategories: 'NotesCategory',
  permissionGroups: 'PermissionGroup',
  permissions: 'Permission',
  prices: 'Price',
  questionDigitisationRuns: 'QuestionDigitisationRun',
  questionEnrichments: 'QuestionEnrichment',
  questionFaults: 'QuestionFault',
  questionOccurrences: 'QuestionOccurrence',
  questions: 'Question',
  questionSets: 'QuestionSet',
  rooms: 'Room',
  schools: 'School',
  sourceDocuments: 'SourceDocument',
  staff: 'Staff',
  streams: 'Stream',
  studentActivityLog: 'StudentActivityLog',
  students: 'Student',
  studentSubjectAnalytics: 'StudentSubjectAnalytics',
  topicGroups: 'TopicGroup',
  topics: 'Topic',
  tutorials: 'Tutorial',
  uploads: 'Upload',
  userNotes: 'UserNote',
  userPermissions: 'UserPermission',
  users: 'User',
  videoCategories: 'VideoCategory',
  videos: 'Video',
  vocabularies: 'VocabularyTerm',
};
